import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";

const EmployeeFilterForm = ({
  applyFilter,
  siteTypes=[],
  statusId,
  // assignedAreas=[],
  reportees=[],
}) => {
  const filterInputs = {
    site_no: "",
    client_name: "",
    site_type: "",
    status: statusId,
    assignee_ids: "",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  useEffect(() => {
    setFilterFieldsData({...filterFieldsData, status : statusId})
    localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
  }, [statusId])

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(
        localStorage.getItem("applyFilter") &&
          localStorage.getItem("applyFilter")
      );
     
      if (roles) {
        setFilterFieldsData(roles);

      }
    })();
  }, []);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setFilterFieldsData({...filterFieldsData, status: statusId});
        applyFilter(filterFieldsData);
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));

      }}
    >
      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        regex={Regex.number.test(filterFieldsData.site_no)}
        type="number"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />
      <ConstantInput
        label={localization.clientName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />

      <DropDownInput
        disabled={siteTypes.length === 0}
        label={localization.status}
        data={siteTypes}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, status: val.id })
        }
      />
      {/* <DropDownInput
        disabled={assignedAreas.length === 0}
        label={localization.assignedArea}
        data={assignedAreas}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, assigned_area: val.id })
        }
      /> */}
      <DropDownInput
        disabled={reportees.length === 0}
        label={localization.assignee}
        data={reportees}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, assignee_ids: val.id })
        }
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br/>
        <br/>
        <button
          onClick={() => {
            localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
            applyFilter(filterInputs);
            localStorage.setItem("statusFilter", JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default EmployeeFilterForm;
